<template>
  <div>
      <table-element
        :title="$t('OrderCurrent.title')"
        :fields="fieldsObj"
        :arrOfElement="filteredOrders"
        :sortSpacing="calculateSortSpacing"
        :isShowSelectAll="true"
        :driversSort="disableDefaultSort"
        :sortable="true"
        :isShowFilter="true"
        class="card mx-2 my-4"
        @updateFilterResults="updateFilterResults"
        @updateSelectedOrders="updateSelectedOrders"
      >
        <template #header-actions>
          <div v-if="!isViewer" class="header-actions">
            <button v-if="currentPageBtn" :disabled="!hasFullAccess || selected.length < 1" @click="openDispatch(); clearfeedbackMessage()" class="m-1 btn btn-kne-orange" >
              {{$t('OrderCurrent.actions.shortDispatch')}}
            </button>

            <button
              :disabled="!canManageInventory || !hasEligibleInventorySelection"
              @click="openSendToInventory"
              class="m-1 btn btn-kne-orange"
            >
              <i class="fa fa-warehouse mr-1" />
              {{ $t('Inventory.sendToInventory') || 'Send to inventory' }}
            </button>
            <p v-show="!shortDispatch && !quickEdit" class="red-text mb-0">{{feedbackMessage}}</p>

            <button v-if="($store.state.userInfo && isQuickBook && isBillingBtn)" :disabled="!hasFullAccess || selected.length < 1" @click="openBilling()" class="m-1 btn btn-kne-orange">
              {{$t('OrderCurrent.actions.billing')}}
            </button>

            <button v-if="($store.state.userInfo && isOdooBillingEnabled && isBillingBtn && !fromToBillPage)" :disabled="!hasFullAccess || selected.length < 1" @click="openBilling(true)" class="m-1 btn btn-kne-orange">
              {{$t('OrderCurrent.actions.billingOdoo')}}
            </button>

            <button v-if="($store.state.userInfo && isOdooBillingEnabled && fromToBillPage)" :disabled="!hasFullAccess || selected.length < 1" @click="addSelectedToOdooQueue()" class="m-1 btn btn-kne-orange">
              {{$t('OrderCurrent.actions.addToOdooQueue')}}
            </button>

            <button v-if="($store.state.userInfo && isOdooBillingEnabled && fromToBillPage)" :disabled="!hasFullAccess || odooBillingQueue.length < 1" @click="openOdooQueueBilling()" class="m-1 btn btn-kne-orange">
              {{$t('OrderCurrent.actions.sendOdooQueue')}} ({{ odooBillingQueue.length }})
            </button>

            <button v-if="($store.state.userInfo && isOdooBillingEnabled && fromToBillPage && odooBillingQueue.length > 0)" @click="clearOdooQueue()" class="m-1 btn btn-danger">
              {{$t('OrderCurrent.actions.clearOdooQueue')}}
            </button>

            <button :disabled="!hasFullAccess || selected.length < 1" @click="openQuickEdit(); clearfeedbackMessage()" class="m-1 btn btn-kne-orange">
              {{$t('OrderCurrent.actions.quickEdit')}}
            </button>

            <button :disabled="!hasFullAccess || selected.length < 1" @click="openUpdatePayer(); clearfeedbackMessage()" class="m-1 btn btn-kne-orange">
              {{$t('OrderCurrent.actions.updatePayer')}}
            </button>

            <button v-if="currentPageBtn" :disabled="!hasFullAccess || selected.length < 1" @click="openSplitLoadModal()" class="m-1 btn btn-kne-orange" >
              {{$t('OrderCurrent.actions.split_load')}}
            </button>

            <button :disabled="!hasFullAccess || selected.length < 1" @click="openStatusEdit();" class="m-1 btn btn-kne-orange">
              {{$t('OrderCurrent.actions.quick_status')}}
            </button>

            <!-- For Marketplace (unused rn) -->
            <!-- <button :disabled="!hasFullAccess || selected.length < 1" @click="openOffer(); clearfeedbackMessage()" class="m-1 btn btn-kne-orange" >
              {{ $t('OrderCurrent.actions.send_to_marketplace') }}
            </button> -->

            <button v-if="lateOrdersPresent && currentPageBtn" :disabled="!hasFullAccess || selected.length < 1" @click="openLateTimeExtentionModal();" class="m-1 btn btn-kne-orange">
              {{$t('OrderCurrent.actions.late_time_extension')}}
            </button>

            <button :disabled="!hasFullAccess || selected.length < 1" @click="openVinPrinting(); clearfeedbackMessage()" class="m-1 btn btn-kne-orange">
              {{$t('OrderCurrent.actions.printVin')}}
            </button>

            <custom-json-excel
              class="btn btn-kne-orange pull-right m-1"
              v-if="isAdmin"
              :filterResults="filterResults"
              :customerFields="customers_fields"
              :name="'order_current_' + getExportDate() + '.xls'"
              />

            <button v-if="currentPageBtn" :disabled="!hasFullAccess || lateOrdersPresent || !hasFullAccess" @click="showFilterZonesModal = true" class="btn btn-kne-orange m-1">
              {{ $t('Zone.filter_zones') }}
            </button>

            <filter-zones-modal v-if="showFilterZonesModal" 
                :pickZones="pickZones" :dropZones="dropZones" 
                :filteredPickZones="filteredPickZones" :filteredDropZones="filteredDropZones"
                @closeModal="showFilterZonesModal = false" @filterZones="filterZones" />

            <button v-if="currentPageBtn" :disabled="!hasFullAccess || selected.length < 1" @click="openVehicleReadyModal(); clearfeedbackMessage()" class="m-1 btn btn-kne-orange">
              {{$t('OrderCurrent.actions.vehicleNotReady')}}
            </button>

            <button v-if="!visibleLateOrders && currentPageBtn" class="m-1 btn btn-kne-orange" @click="showLateOrders">
              {{$t('OrderCurrent.actions.show_late_orders')}}
            </button>

            <button v-if="visibleLateOrders && currentPageBtn" class="m-1 btn btn-kne-orange" @click="showLateOrders">
              {{$t('OrderCurrent.actions.hide_late_orders')}}
            </button>

            <button :disabled="!hasFullAccess" @click="openCustomizeModal(); clearfeedbackMessage()" class="btn btn-kne-orange customize-btn" :title="$t('OrderCurrent.actions.customize')">
              <i class="fa fa-cog" aria-hidden="true"></i>
            </button>
          </div>
        </template>

        <template #body-content-desktop="content">
          <!-- List of orders -->
          <tr v-for="(order, index) in content.results"
          class="table-element_hover text-center"
          :key="order['.key']"
          :class="{
            'late': orderTiming(order).delay > 0,
            'red': isLateOrder(order),
            'orange': order.isPartialLate,
            'yellow': isWarningOrder(order) && !isLateOrder(order),
            'drop': order.status === 'Drop',
            'cancel': order.status === 'Cancel',
            'waiting': order.status === 'Attente',
            'pick': order.status === 'Pick',
            'transit': order.status === 'Transit',
            'dispatch': order.status === 'Dispatch',
            'reject': order.status === 'Reject',
            'inspection': order.status === 'Inspection',
            'transfered': order.status === 'Transférée'
            }">
            <td class="pt-2">
              <label class="custom-control custom-checkbox my-2 ml-2 mr-0">
                <input :value="order['.key']" v-model="selected" type="checkbox" class="custom-control-input" :disabled="disableActions(order)" > 
                <span class="custom-control-indicator" :class="{'uncheck': !selected.includes(order['.key']), 'check': selected.includes(order['.key'])}"></span>
              </label>
            </td>
            <td class="pt-2">
              <router-link :to="{name: 'OrderInfo', query: {orderId: order['.key']}}">
                <input type="button" class="btn btn-kne-orange" :value="$t('OrderCurrent.view')" :disabled="disableActions(order)" >
              </router-link>
            </td>
            <td v-if="!isDateRoute" class="pt-2">
              <a :href="order.invoice" target="_blank" @click="print(order)" :disabled="disableActions(order)">
                <button class="btn btn-kne-orange" :class="{'printed': order.isPrinted}" :disabled="disableActions(order)">
                  <i class="fa fa-print" aria-hidden="true" />
                </button>
              </a>
            </td>

            <td v-if="order.docs && currentPageBtn" class="pt-2">
              <i class="fa fa-file mt-2" aria-hidden="true" />
            </td>
            
            <td v-if="!order.docs && currentPageBtn" class="pt-2">
              <input v-if="checkDate(order.dateSignataire)" type="button" class="btn btn-kne-green" :value="calcBusinessDays(order.dateSignataire)">
              <input v-if="!checkDate(order.dateSignataire)" type="button" class="btn btn-kne-red" :value="calcBusinessDays2(order.dateSignataire)">
            </td>
            <td v-if="!currentPageBtn && order.receiverAddress && order.historySync && order.receiverAddress !== lastHistorySync(order.historySync, 'receiverAddress')" class="pt-2">
              <button class="btn btn-kne-yellow tooltip-wrapper">
                  <i class="fa fa-solid fa-exclamation"></i>
                <span class="tooltip-text">
                  {{ $t('OrderDelivered.initial_drop') + ': '}} <strong>{{ order.receiverAddress }}</strong>
                  <br>
                  {{ $t('OrderDelivered.actual_drop') + ': ' }} <strong>{{ lastHistorySync(order.historySync, 'receiverAddress') }}</strong>
                </span>
              </button>
            </td>
            <td v-else-if="!currentPageBtn" class="pt-2">
              <button class="btn btn-kne-green tooltip-wrapper">
                  <i class="fa fa-solid fa-check"></i>
                <span class="tooltip-text">
                  {{ $t('OrderDelivered.drop_addresses_same') }}
                </span>
              </button>
            </td>
            <td class="pt-2" v-if="isDateRoute">
                <input v-if="checkDate(order.datePromis)" type="button" class="btn btn-kne-red" :value="calcBusinessDays(order.datePromis)">
                <input v-if="!checkDate(order.datePromis)" type="button" class="btn btn-kne-green" :value="calcBusinessDays2(order.datePromis)">
            </td>
            
            <td
              v-for="field in fieldsObj"
              :key="field.type"
              class="pt-3 nowrap"
            >
            
              <template v-if="field.type === 'survey'">
                <hover-tool-tip
                  v-if="order.survey"
                  :text="getOrderSurvey(order.survey)"
                  :iconColor="getSurveyIconColor(order.survey)"
                  :displayFixed="true"
                  bottom
                  right
                />
              </template>
              <template v-else-if="field.type === '.key'">
                <div v-if="order.isOdooInvoiceGroupRow">
                  <div class="fw-700">{{ $t('OrderCurrent.modal.odoo_group') }} ({{ order.groupedOrderCount }})</div>
                  <div class="grouped-orders-list">{{ order.groupedOrderKeys.join(', ') }}</div>
                </div>
                <span v-else>{{ order['.key'] }}</span>
                <span v-if="order.sentToInventory" class="badge badge-warning ml-1">
                  {{ $t('Inventory.sentToInventory') || 'Sent to inventory' }}
                </span>
                <hover-tool-tip
                  :text="`<div>
                            ${order.source || '-'}
                            <br>${getDate(order.creationDate) || '-'}
                            <br>${orderSummaryLine(order)}
                          </div>`"
                  :top="true"
                  :right="true"
                  clickable
                />
                <hover-tool-tip
                  v-if="order.historySync"
                  :text="dispatchHistToolTip(order)"
                  :iconText="getOrderHistoryLength(order)"
                  iconColor="black"
                  iconBackgroundColor="white"
                  :top="true"
                  :right="true"
                />
              </template>

              <template v-else-if="field.type === 'numRef'">
                {{ order.numRef || '-' }}
              </template>

              <template v-else-if="field.type === 'vin'">
                {{ order.vin || '-' }}
              </template>

              <template v-else-if="field.type === 'model'">
                {{ order.model || '-' }}
                <hover-tool-tip
                  :text="modelColumnTooltip(order)"
                  :left="true"
                  :top="true"
                  clickable
                />
              </template>

              <template v-else-if="field.type === 'datePromis'">
                {{ order.datePromis || '-' }}
              </template>

              <template v-else-if="field.type === 'transmitterName'">
                <div v-if="order.historySync && ['Dispatch','Pick','Transit','Drop'].includes(order.status)">
                  <div>
                    {{ shortenString($realName(order, 'transmitter')) || '-' }}
                    <hover-tool-tip
                      :text="`<p>
                        ${lastHistorySync(order.historySync,'transmitterAddress') || '-'}
                        ${lastHistorySync(order.historySync,'transmitterCity') || '-'}
                        <br>
                        ${lastHistorySync(order.historySync,'transmitterProvince') || '-'}
                        ${lastHistorySync(order.historySync,'transmitterPostcode') || '-'},
                        ${lastHistorySync(order.historySync,'transmitterCountry') || '-'}
                      </p>`"
                      :left="true"
                      :top="true"
                      clickable
                    />
                  </div>
                  <div class="fw-700">({{ order.transmitterZone || '-' }})</div>
                </div>

                <div v-else>
                  <div>
                    {{ shortenString($realName(order, 'transmitter')) || '-' }}
                    <hover-tool-tip
                      :text="`<p>
                        ${order.transmitterAddress || '-'}
                        ${order.transmitterCity || '-'}
                        <br>
                        ${order.transmitterProvince || '-'}
                        ${order.transmitterPostcode || '-'},
                        ${order.transmitterCountry || '-'}
                      </p>`"
                      :left="true"
                      :top="true"
                      clickable
                    />
                  </div>
                  <div v-if="order.transmitterZone" class="fw-700">
                    ({{ order.transmitterZone }})
                  </div>
                </div>
              </template>

              <template v-else-if="field.type === 'receiverName'">
                <div v-if="order.historySync && ['Dispatch', 'Pick', 'Transit', 'Drop'].includes(order.status)">
                    <div>{{shortenString($realName(order, 'receiver')) || '-'}}
                    <hover-tool-tip
                      :text="`<p>${order.receiverAddress || '-'} ${order.receiverCity || '-'}
                                <br>${order.receiverProvince || '-'} ${order.receiverPostcode || '-'}, ${order.receiverCountry || '-'}
                              </p>`"
                      :left="true"
                      :top="true"
                      clickable
                    />
                  </div>
                  <div class="fw-700">({{ order.receiverZone || '-' }})</div>
                </div>
                <div v-if="!order.historySync || !['Dispatch', 'Pick', 'Transit', 'Drop'].includes(order.status)">
                  <div>{{ shortenString($realName(order, 'receiver'))|| '-'}}
                    <hover-tool-tip
                      :text="`<p>${order.receiverAddress || '-'} ${order.receiverCity || '-'}
                                <br>${order.receiverProvince || '-'} ${order.receiverPostcode || '-'}, ${order.receiverCountry || '-'}
                              </p>`"
                      :left="true"
                      :top="true"
                      clickable
                    /> </div>
                  <div v-if="order.receiverZone" class="fw-700">({{order.receiverZone}})</div>
                </div>
              </template>

              <!-- ========== BILLING / PRICE ========== -->
              <template v-else-if="field.type === 'payerName'">
                <div>{{ shortenString($realName(order, 'payer')) || '-' }}
                  <hover-tool-tip
                    v-if="order.billingComment"
                          :text="`<p>
                                    ${order.billingComment}
                                  </p>`"
                          :top="true"
                          :right="true"
                          :iconColor="'yellow'"
                          :iconClass="'fa-file-invoice-dollar'"
                          clickable
                        />
                  <hover-tool-tip
                    v-if="order.includedFuelCharge"
                    :text="'Fuel Charge Included'"
                    :top="true"
                    :iconColor="'red'"
                    :iconClass="'fa-gas-pump'"
                    clickable
                  />
                </div>
              </template>

              <template v-else-if="field.type === 'regularPrice'">
                <div class="fw-700">
                  <div>
                    {{ order.price !== undefined ? 'Actual Price: ' + order.price + '$' : '-' }}
                  </div>
                  <div>
                    {{ order.regularPrice !== undefined ? 'Expected Price: ' + order.regularPrice + '$' : '-' }}
                  </div>
                  <hover-tool-tip
                    :text="generateTooltip(order)"
                    :left="true"
                    :top="true"
                    clickable
                  />
                  <hover-tool-tip
                    v-if="order.includedFuelCharge"
                    :text="'Fuel Charge Included'"
                    :top="true"
                    :iconColor="'red'"
                    :iconClass="'fa-gas-pump'"
                    clickable
                    />
                </div>
              </template>

              <template v-else-if="field.type === 'eta'">
                <p class="table-fix-width px-2">
                  {{ orderTiming(order).eta }}
                </p>
                <hover-tool-tip
                  :text="`${$t('OrderCurrent.current_delay')}: ` + orderTiming(order).delay"
                  :left="true"
                  :top="true"
                  :clickable="false"
                />
              </template>

              <template v-else-if="field.type === 'status'">
                <status-badge
                  v-if="order.isMarketplaceOffer"
                  status="Marketplace"
                  :custom-label="$t('Search.status.marketplace')"
                  size="sm"
                />
                <status-badge
                  v-else
                  :status="order.status"
                  size="sm"
                />
                <hover-tool-tip
                  v-if="order.notes"
                  :text="getOrderNotes(order.notes)"
                  :left="true"
                  :top="true"
                  :clickable="false"
                />
              </template>

              <template v-else-if="field.type === 'odooStatus'">
                <span :class="getOdooStatusClass(order)">{{ getOdooStatusText(order) }}</span>
              </template>

              <!-- ========== DRIVER ========== -->
              <template v-else-if="field.type === 'driverName'">
                <p class="table-fix-width">{{ order.driverName || '-' }}</p>
              </template>

              <template v-else-if="field.type === 'action'">
                <div v-if="fromDeliveredPage">
                  <div id="action">
                    <button class="btn btn-kne-orange m-2"  @click="confirmBilling(order)">
                      <i class="fa fa-check" aria-hidden="true" />
                    </button>
                    <button class="btn btn-kne-orange m-2" @click.once="openStatusEdit()">
                      <i class="fa fa-times" aria-hidden="true" />
                    </button>
                  </div>
                </div>
                <div v-if="fromToBillPage">
                  <div v-if="isOdooBillingEnabled" id="action" class="to-bill-actions">
                    <span :class="getOdooStatusClass(order)" class="odoo-status-text">{{ getOdooStatusText(order) }}</span>
                    <button v-if="!isOrderQueued(order)" class="btn btn-kne-orange m-2" @click="addOrderToOdooQueue(order)">
                      <i class="fa fa-plus" aria-hidden="true" />
                    </button>
                    <button v-else class="btn btn-danger m-2" @click="removeOrderFromOdooQueue(order)">
                      <i class="fa fa-minus" aria-hidden="true" />
                    </button>
                  </div>
                  <div v-else id="action">
                    <button class="btn btn-kne-orange m-2" @click="openStatusEdit()">
                      <i class="fa fa-check" aria-hidden="true" />
                    </button>
                    <!-- <button class="btn btn-kne-orange m-2" :disabled="inProgress === order['.key']" @click.once="openStatusEdit()">
                      <i class="fa fa-times" aria-hidden="true" />
                    </button> -->
                  </div>
                </div>
              </template>

              <template v-else>
                {{ order[field.type] || '-' }}
              </template>
            </td>
          </tr>
        </template>

        <template #col-survey="{ order }">
          <td class="pt-3">
            <hover-tool-tip
              v-if="order.survey"
              :text="getOrderSurvey(order.survey)"
              :iconColor="getSurveyIconColor(order.survey)"
              :displayFixed="true"
              bottom
              right
            />
          </td>
        </template>

        <template #body-content-mobile="content">
          <div class="card my-3 mx-2" v-for="(order) in content.results"
          :key="order['.key']"
          :class="{
            'red': isLateOrder(order),
            'orange': order.isPartialLate,
            'yellow': isWarningOrder(order) && !isLateOrder(order),
            'drop': order.status === 'Drop',
            'cancel': order.status === 'Cancel',
            'waiting': order.status === 'Attente',
            'pick': order.status === 'Pick',
            'transit': order.status === 'Transit',
            'dispatch': order.status === 'Dispatch',
            'reject': order.status === 'Reject',
            'inspection': order.status === 'Inspection'
          }">
            <div style="display: flex;">
              <label class="custom-control custom-checkbox form-control-lg mt-1 ml-2" id="checkBox">
                <input :value="order['.key']" v-model="selected" type="checkbox" class="custom-control-input">
                <span class="custom-control-indicator form-control-lg"></span>
              </label>
              <div v-if="order.docs" id="fileIcon">
                  <i class="fa fa-file" aria-hidden="true" />
              </div>
            </div>

            <div class="card-header m-2">
              <h4>{{order['.key']}}</h4>
              <p v-if="isDateRoute"><i class="fa fa-calendar" />{{ order.datePromis }}</p>
              <p><i class="fa fa-calendar" />{{ getDate(order.creationDate) }}</p>
              <p v-if="order.status === 'Dispatch'"><i class="fa fa-exclamation" /> {{$t('Search.status.dispatch')}}</p>
              <p v-if="order.status === 'Processing'"><i class="fa fa-exclamation" /> {{$t('Search.status.processing')}}</p>
              <p v-if="order.status === 'Pick'"><i class="fa fa-exclamation" /> {{$t('Search.status.pick')}}</p>
              <p v-if="order.status === 'Waiting'"><i class="fa fa-exclamation" /> {{$t('Search.status.waiting')}}</p>
              <p v-if="order.status === 'Transit'"><i class="fa fa-exclamation" /> {{$t('Search.status.transit')}}</p>
              <p v-if="order.status === 'Drop'"><i class="fa fa-exclamation" /> {{$t('Search.status.drop')}}</p>
              <p v-if="order.status === 'Cancel'"><i class="fa fa-exclamation" /> {{$t('Search.status.canceled')}}</p>
              <p v-if="order.status === 'Terminée'"><i class="fa fa-exclamation" /> {{$t('Search.status.finished')}}</p>
              <p v-if="order.status === 'Transférée'"><i class="fa fa-exclamation" /> {{$t('Search.status.transfered')}}</p>
              <p v-if="order.status === 'Reject'"><i class="fa fa-exclamation" /> {{$t('Search.status.rejected')}}</p>
              <p v-if="order.status === 'Inspection'"><i class="fa fa-exclamation" /> {{$t('Search.status.inspection')}}</p>
            </div>

            <p v-if="!order.docs"> </p>
            <div class="m-2" v-if="isDateRoute">
              <input v-if="checkDate(order.datePromis)" type="button" class="btn btn-kne-red" :value="calcBusinessDays(order.datePromis)">
              <input v-if="!checkDate(order.datePromis)" type="button" class="btn btn-kne-green" :value="calcBusinessDays2(order.datePromis)">
            </div>

            <div class="m-2">
              <p v-if="isPalletOrder(order)">
                <span><i class="fa fa-cube" /> {{ palletSummary(order) }}</span>
                <span v-if="order.weight"> | {{ order.weight }} lb</span>
              </p>
              <p v-else>
                <span><i class="fas fa-tools" /> {{order.make || '-'}}</span>
                <span>| <i class="fa fa-car" /> {{order.model || '-'}}</span>
                <span>| <i class="fas fa-calendar-alt" /> {{order.year || '-'}}</span>
              </p>
              <p><i class="fa fa-user" /> {{order.driverName || '-'}}</p>
              <p><i class="fa fa-home" /> {{$realName(order, 'transmitter') || '-'}}</p>
              <p><i class="fa fa-truck" /> {{$realName(order, 'receiver') || '-'}}</p>
              <p><i class="fa fa-credit-card" /> {{$realName(order, 'payer') || '-'}}</p>
              <p v-if="order.sentToInventory" class="text-warning">
                <i class="fa fa-warehouse" /> {{ $t('Inventory.sentToInventory') || 'Sent to inventory' }}
              </p>
            </div>

            <div id="action">
              <router-link :to="{name: 'OrderInfo', query: {orderId: order['.key']}}">
                <input type="button" class="btn btn-kne-orange m-2" :value="$t('OrderCurrent.view')">
              </router-link>
              <div v-if="!isDateRoute">
                <a :href="order.invoice" target="_blank" @click="print(order)">
                  <button class="btn btn-kne-orange m-2" :class="{'printed': order.isPrinted}">
                    <i class="fa fa-print" aria-hidden="true" />
                  </button>
                </a>
              </div>
            </div>
          </div>
        </template>
      </table-element>

      <!-- Action Modals  -->
      <div>
        <short-dispatch-modal
          v-if="isShortDispatchModal"
          ref="shortDispatchModal"
          :arrOfOrder="selectedFull"
          :liste="liste"
          :addressbook="addressbook"
          :priceOrderLink="priceOrderLink"
          :isOpen="isShortDispatchModal"
          :isOrderNbClickable="true"
          @closeModal="isShortDispatchModal = false; clear()"
          @clearSelected="clearSelected"
          />

        <send-to-inventory-modal
          v-if="isSendToInventoryModal"
          :orders="selectedInventoryOrders"
          :drivers="inventoryDrivers"
          @close="closeSendToInventory"
          @completed="onInventoryOrdersCreated"
        />
    
        <create-offer-modal
          v-if="isCreateOfferModal"
          ref="shortDispatchModal"
          :arrOfOrder="selectedFull"
          :liste="liste"
          :addressbook="addressbook"
          :priceOrderLink="priceOrderLink"
          :isOpen="isCreateOfferModal"
          :isOrderNbClickable="true"
          @closeModal="isCreateOfferModal = false; clear()"
          @clearSelected="clearSelected"
        />
        <status-change-modal
          v-if="isStatusEdit"
          ref="shortDispatchModal"
          :arrOfOrder="selectedFull"
          :isOpen="isStatusEdit"
          :priceOrderLink="priceOrderLink"
          @closeModal="isStatusEdit = false; clear()"
          @clearSelected="clearSelected"
        />
    
        <late-time-extension-modal
          v-if="lateTimeExtension"
          ref="shortDispatchModal"
          :arrOfOrder="selectedFull"
          :isOpen="lateTimeExtension"
          :priceOrderLink="priceOrderLink"
          @closeModal="lateTimeExtension = false; clear(); recheckLateOrdersAfterExtension()"
          @clearSelected="clearSelected"
        />
    
        <late-time-extension-modal
          v-if="vehicleReadyModal"
          ref="shortDispatchModal"
          :arrOfOrder="selectedFull"
          :isOpen="vehicleReadyModal"
          :priceOrderLink="priceOrderLink"
          :isVehicleReadyModal="true"
          @closeModal="vehicleReadyModal = false; clear()"
          @clearSelected="clearSelected"
        />

        <billing-new
          :billing="billing"
          :isOdooBill="isOdooBill"
          :arrOfOrder="selectedFull"
          @closeBillingModal="closeModals"
        />

        <quick-edit
          :quickEdit="quickEdit"
          :arrOfOrder="selectedFull"
          :user="user"
          @closeQuickModal="closeModals"
        />

        <update-payer-modal
          :quickPayerEdit="quickPayerEdit"
          :arrOfOrder="selectedFull"
          :clientAccounts="clientAccounts"
          @closePayerModal="closeModals"
        />

        <split-load-modal 
          :splitLoadModal="splitLoadModal"
          :arrOfOrder="selectedFull"
          @closeSplitLoadModal="closeModals"
        />
    
        <print-vin 
          v-if="vinPrinting"
          :vinPrinting="vinPrinting"
          :arrOfOrder="selectedFull"
          :user="user"
          @closePrintVin="closeModals"
        />

        <customize-table-layout-modal
          v-if="showCustomizeModal"
          :showCustomizeModal="showCustomizeModal"
          :columns="tableLayoutOptions"
          :initalSelections="layout"
          @saveTableCustomizations="saveTableCustomizations"
          @closeCustomizeTable="closeModals"
        />
      </div>
  </div>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import regularCheckbox from '../../basic-components/regularCheckbox.vue'
import regularDatalistDriver from '../../basic-components/regularDatalistDriver.vue'
import regularTextarea from '../../basic-components/regularTextarea.vue'
import regularSelect from '../../basic-components/regularSelect.vue'
import hoverToolTip from '../../basic-components/hoverToolTip.vue'
import Search from '../Other-components/Search.vue'
import TableElement from './Table-Element.vue'
import feeSelector from '../../basic-components/feeSelector.vue'

import ShortDispatchModal from '../Modal-templates/ShortDispatch-modal.vue'
import StatusChangeModal from '../Modal-templates/StatusChange-modal.vue'
import LateTimeExtensionModal from '../Modal-templates/LateTimeExtension-modal.vue'
import CreateOfferModal from '../Modal-templates/CreateOffer-modal.vue'
import CustomDatePick from '../Custom-packages/Custom-DatePick.vue'
import CustomJsonExcel from '../Custom-packages/Custom-JsonExcel.vue'
import QuickEdit from '../Modal-templates/QuickEdit.vue'
import BillingNew from '../Modal-templates/BillingNew.vue'
import UpdatePayerModal from '../Modal-templates/UpdatePayerModal.vue'
import PrintVin from '../Modal-templates/PrintVin.vue'
import FilterZonesModal from '../Modal-templates/FilterZones-modal.vue'
import SplitLoadModal from '../Modal-templates/SplitLoad-modal.vue'
import CustomizeTableLayoutModal from '../Modal-templates/CustomizeTableLayout-modal.vue'
import StatusBadge from '../Other-components/StatusBadge.vue'
import SendToInventoryModal from '../Inventory/SendToInventoryModal.vue'

import {db} from '../../../../firebase'
import JsonExcel from 'vue-json-excel'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import * as firebaseUtil from '../../../../firebase.js'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'
import { dryBoxMixin } from '../../../../utils/dryBoxLabels'
import { isRegularOrder } from '../../../../inventory/inventorySelectors'

export default {
    name: 'TableListing',
    mixins: [dryBoxMixin],
    components: {
      Modal,
      regularCheckbox,
      regularTextarea,
      regularSelect,
      hoverToolTip,
      feeSelector,
      Search,
      regularDatalistDriver,
      JsonExcel,
      vueDropzone: vue2Dropzone,
      VueGoogleAutocomplete,
      DatePick,
      TableElement,
      ShortDispatchModal,
      CreateOfferModal,
      StatusChangeModal,
      CustomDatePick,
      CustomJsonExcel,
      FilterZonesModal,
      LateTimeExtensionModal,
      QuickEdit,
      PrintVin,
      BillingNew,
      UpdatePayerModal,
      SplitLoadModal,
      CustomizeTableLayoutModal,
      StatusBadge,
      SendToInventoryModal
    },

    data () {
        return {
          fieldsObjEDI: [
            {
              text: this.$t('OrderCurrent.order'),
              type: 'orderNumber',
              value: ''
            },
            {
              text: this.$t('OrderCurrent.source'),
              type: 'source',
              value: ''
            },
            {
              text: this.$t('OrderCurrent.reference'),
              type: 'numRef',
              value: ''
            },
            {
              text: this.$t('OrderCurrent.reason'),
              type: 'note',
              value: ''
            },
            {
              text: this.$t('OrderPending.orderTab.addOdooFee'),
              type: '',
              value: ''
            },
            {
              text: this.$t('OrderInfo.modal.price'),
              type: 'price',
              value: ''
            },
            {
              text: this.$t('OrderPending.orderTab.odooComment'),
              type: 'odooComment',
              value: ''
            }
          ],
          customers_fields: {
            'Order': 'order',
            'Ref': 'numRef',
            'Source': 'source',
            [this.fieldLabel('vin', 'VIN')]: 'vin',
            'Date': 'billingDate',
            'Pick': { callback: (order) => this.$realName(order, 'transmitter') },
            'Drop': { callback: (order) => this.$realName(order, 'receiver') },
            'Billing': { callback: (order) => this.$realName(order, 'payer') },
            'Status': 'status',
            'Driver': 'driverName',
            'Province pick': 'transmitterProvince',
            'Province drop': 'receiverProvince',
            'Remark': 'comment',
            ...(this.$store.state.userInfo && this.$store.state.userInfo.isDryBox ? {
              [this.$t('DryBox.qty')]: 'year',
              [this.$t('DryBox.line_weight')]: 'weight',
              [this.$t('DryBox.linear_feet')]: 'linearFeet'
            } : {})
          },
          VIN: '',
          MAKE: '',
          MODEL: '',
          YEAR: '',
          SIZE: '',
          vehicles: [],
          user: {
            name: '',
            address: '',
            city: '',
            zipCode: '',
            province: '',
            phone: '',
            nir: '',
            cigle: '',
            logo: ''
          },
          layout: [],
          pricingAndDelay: [],
          pickupSave: false,
          deliverySave: false,
          billingSame: false,
          datalist: {
            pickup: '',
            pickupUid: '',
            delivery: '',
            deliveryUid: '',
            billing: '',
            billingUid: ''
          },
          fields: {
            '.key': '',
            numRef: '',
            source: '',
            vin: '',
            datePromis: '',
            dateSignataire: '',
            docs: '',
            creationDate: '',
            receiverName: '',
            transmitterName: '',
            payerName: '',
            status: '',
            driverName: ''
          },
          backup: {
            sageIDDelivery: ''
          },
          filterResults: [],
          // processing: [],
          addressbook: [],
          makeList: ['Acura', 'Alfa Romeo', 'AM General', 'AMC', 'Aston Martin', 'Audi', 'Bentley', 'BMW', 'Bugatti', 'Buick', 'Cadillac', 'Chevrolet', 'Chrysler', 'Daewoo', 'Daihatsu', 'Datsun', 'DeLorean', 'Dodge', 'Eagle', 'Ferrari', 'FIAT', 'Fisker', 'Ford', 'Genesis', 'Geo', 'GMC', 'Honda', 'HUMMER', 'Hyundai', 'INFINITI', 'Isuzu', 'Jaguar', 'Jeep', 'Karma', 'Kia', 'Lamborghini', 'Land Rover', 'Lexus', 'Lincoln', 'Lotus', 'Maserati', 'Maybach', 'Mazda', 'McLaren', 'Mercedes-Benz', 'Mercury', 'Merkur', 'MINI', 'Mitsubishi', 'Nissan', 'Oldsmobile', 'Panoz', 'Pininfarina', 'Plymouth', 'Pontiac', 'Porsche', 'Ram', 'Renault', 'Rolls-Royce', 'Saab', 'Saturn', 'Scion', 'Smart', 'Sterling', 'Subaru', 'Suzuki', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo', 'Yugo'],
          selected: [],
          odooBillingQueue: [],
          selectedWithOrderNo: [],
          selectedFull: [],
          selectedFull2: [],
          billing: false,
          isOdooBill: false,
          dispatch: false,
          vinPrinting: false,
          splitLoadModal: false,
          hideTitleonPrint: false,
          shortDispatch: false,
          quickEdit: false,
          quickPayerEdit: false,
          dispatchOrder: {
            chauffeur: '',
            chauffeurName: ''
          },
          allDeliveries: [],
          customViews: [],
          selectedCustomView: '',
          autocompleteSearchFields: ['address_components', 'adr_address', 'formatted_address', 'formatted_phone_number', 'geometry', 'id', 'name', 'place_id', 'type', 'vicinity'],
          // 'utc_offset_minutes', 'url', 'photo', 'business_status', 'icon', 'scope', 'alt_id',
          badVin: false, // New Order, invalid VIN check
          vueGoogleAutocomplete: false,
          addressBookSearch: true,
          priceOrderLink: [], // This is to create a price/order link list for dispatches
          feedbackMessage: '',
          areAllOrdersSelected: false,
          selectedContactEmails: [],
          isNewOrderModal: false,
          isDistributedModal: false,
          isDeliveryLocationModal: false,
          isStatusEdit: false,
          lateTimeExtension: false,
          vehicleReadyModal: false,
          selectedOrder: {}, // For changing date in Short Dispatch
          isShortDispatchModal: false,
          isCreateOfferModal: false,
          spreadDate: '',
          visibleLateOrders: false,
          fieldsObj: [],
          zones: [],
          pickZones: [],
          dropZones: [],
          zonesData: [],
          lateOrders: [],
          filteredPickZones: [],
          filteredDropZones: [],
          originalProcessing: [],
          pendingAccounts: [],
          clientAccounts: {},
          showFilterZonesModal: false,
          firebaseUtil,
          lateOrdersPresent: false,
          ordersListener: null,
          unlistedListener: null,
          unlistedOrderKeys: [],
          unlistedProcessing: null,
          showUnlistedOrders: false,
          showCustomizeModal: false,
          isSendToInventoryModal: false,
          inventoryDriverList: []
        }
    },

    props: {
      arrOfOrders: {
        type: Array,
        required: true
      },
      defaultFieldsObj: {
          type: Array,
          required: true
      },
      lateOrdersArr: {
        type: Array,
        required: false,
        default: () => []
      },
      activeTab: {
        type: String,
        required: true
      },
      liste: {
        type: Array,
        required: false,
        default: () => []
      },
      disableDefaultSort: Boolean,
      isBillingBtn: {
        type: Boolean,
        required: false,
        default: false
      },
      currentPageBtn: {
        type: Boolean,
        required: false,
        default: false
      },
      fromDeliveredPage: {
        type: Boolean,
        required: false,
        default: false
      },
      fromToBillPage: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    mounted () {
      db.ref('users/transporters').child(this.companyUID).once('value').then((snapshot) => {
        this.$store.commit('setUserInfo', snapshot.val() || false)
        this.user = snapshot.val()
      })
      this.loadInventoryDrivers()
    },
    async created () {
      this.getZones()
      await this.loadFieldsObj()
    },
    methods: {
      openDispatch () {
        this.fetchSelected('DISPATCH')
        this.loadAddressBook()
        this.onOpenShortDispatchModal()
      },
      openSendToInventory () {
        if (!this.canManageInventory || !this.hasEligibleInventorySelection) return
        this.isSendToInventoryModal = true
      },
      async loadInventoryDrivers () {
        try {
          const snapshot = await db.ref(`database/transporter/${this.companyUID}/liste`).once('value')
          const drivers = []
          snapshot.forEach(child => {
            const value = child.val()
            drivers.push({
              uid: child.key,
              name: typeof value === 'string'
                ? value
                : (value && (value.name || value.value)) || child.key
            })
          })
          this.inventoryDriverList = drivers.sort((left, right) => left.name.localeCompare(right.name))
        } catch (error) {
          this.inventoryDriverList = []
        }
      },
      closeSendToInventory () {
        this.isSendToInventoryModal = false
      },
      onInventoryOrdersCreated () {
        this.isSendToInventoryModal = false
        this.clearSelected()
      },
      orderSummaryLine (order) {
        if (this.isPalletOrder(order)) return this.palletSummary(order)
        return `${order.make || '-'} ${order.model || '-'} ${order.year || '-'}`
      },
      modelColumnTooltip (order) {
        if (this.isPalletOrder(order)) {
          return `<p>${this.palletDims(order)} × ${order.year || 1}</p>
                  <p>${order.realWeight ? this.$t('DryBox.unit_weight') + ': ' + order.realWeight : ''}</p>
                  <p>${order.weight ? this.$t('DryBox.line_weight') + ': ' + order.weight : ''}</p>
                  <p>${order.linearFeet ? this.$t('DryBox.linear_feet') + ': ' + order.linearFeet : ''}</p>
                  <p>${this.$t('DryBox.stackable')}: ${order.stackable ? this.$t('General.yes') : this.$t('General.no')}</p>`
        }
        return `<p>${this.$t(`Vehicles.${order.size}`) || '-'}</p>
                <p>${order.realWeight ? 'Weight: ' + order.realWeight + ' lbs' : ''}</p>`
      },
      async fetchTableLayout () {
        const snapshot = await db
          .ref('database/transporter')
          .child(this.companyUID)
          .child('userTableLayouts')
          .child(this.uid)
          .child(this.activeTab)
          .once('value')

        return snapshot.val() || []
      },
      transformLayoutToFields (layout) {
        const fields = layout.map(item => ({
          text: this.fieldLabel(item.value, item.text),
          type: item.value,
          value: ''
        }))

        fields.unshift({
          text: `<i class="fa fa-solid fa-clipboard" />`,
          mobileText: this.$t('OrderCurrent.survey'),
          type: 'survey',
          value: ''
        })

        if (this.activeTab === 'delivered' || this.activeTab === 'toBill') {
          fields.push({
            text: this.$t('logs.table_header.action'),
            type: 'action',
            value: ''
          })
        }

        return fields
      },
      async loadFieldsObj () {
        this.layout = await this.fetchTableLayout()

        if (!this.layout.length) {
          this.fieldsObj = this.defaultFieldsObj
          console.log({defaultLayout: this.defaultFieldsObj})
          return
        }

        this.fieldsObj = this.transformLayoutToFields(this.layout)
        console.log({fo: this.fieldsObj})
      },
      columnSlotMap () {
        return {
          survey: 'col-survey',
          '.key': 'col-order',
          numRef: 'col-numRef',
          vin: 'col-vin',
          transmitterName: 'col-pickup',
          receiverName: 'col-delivery',
          payerName: 'col-billing',
          driverName: 'col-driver',
          '': 'col-action'
        }
      },
      onOpenShortDispatchModal () {
        this.isShortDispatchModal = true
      },
      openBilling (isOdooBill = false) {
        this.isOdooBill = isOdooBill
        this.fetchSelected('BILLING')

        this.billing = true
      },
      getOrderKeysForQueue (order) {
        if (order && Array.isArray(order.groupedOrderKeys)) return order.groupedOrderKeys
        const orderKey = order && (order['.key'] || order.key || order.orderNumber)
        return orderKey ? [orderKey] : []
      },
      addOrderToOdooQueue (order) {
        this.getOrderKeysForQueue(order).forEach(orderKey => {
          if (!this.odooBillingQueue.includes(orderKey)) this.odooBillingQueue.push(orderKey)
        })
      },
      removeOrderFromOdooQueue (order) {
        const keysToRemove = this.getOrderKeysForQueue(order)
        this.odooBillingQueue = this.odooBillingQueue.filter(orderKey => !keysToRemove.includes(orderKey))
      },
      isOrderQueued (order) {
        const orderKeys = this.getOrderKeysForQueue(order)
        return orderKeys.length > 0 && orderKeys.every(orderKey => this.odooBillingQueue.includes(orderKey))
      },
      findOrderForQueueKey (orderKey) {
        const visibleOrder = this.filteredOrders.find(order => order['.key'] === orderKey)
        if (visibleOrder) return visibleOrder
        return this.originalProcessing.find(order => order['.key'] === orderKey)
      },
      addSelectedToOdooQueue () {
        this.selected.forEach(orderKey => {
          const order = this.findOrderForQueueKey(orderKey)
          if (order) this.addOrderToOdooQueue(order)
        })
        this.clearSelected()
      },
      clearOdooQueue () {
        this.odooBillingQueue = []
      },
      openOdooQueueBilling () {
        this.isOdooBill = true
        this.selected = [...this.odooBillingQueue]
        this.fetchSelected('BILLING')
        this.billing = true
      },
      openQuickEdit () {
        this.fetchSelected('QUICKEDIT')
        this.quickEdit = true
      },
      openSplitLoadModal () {
        this.fetchSelected('QUICKEDIT')
        this.splitLoadModal = true
      },
      openCustomizeModal () {
        this.showCustomizeModal = true
      },
      openUpdatePayer () {
        this.fetchSelected('QUICKEDIT')
        this.quickPayerEdit = true
        this.$bindAsArray('pendingAccounts', db.ref('users/pending-creation').orderByChild('transporterUid').equalTo(this.companyUID), null, () => {
          let approvedAccounts = this.pendingAccounts.filter(item => item.status === 'Approved' && item.lat && item.long)
          for (let item of approvedAccounts) {
            this.clientAccounts[`${item['.key']}`] = item.name
          }
        })
      },
      confirmBilling (order) {
        const transporterId = this.companyUID
        const orderKey = order['.key'] || order.key
        if (!orderKey) {
          console.error('Missing order key')
          return
        }

        db.ref(`database/transporter/${transporterId}/deliveries/${orderKey}`)
          .update({ isBilling: true })
          .catch((error) => {
            console.error('Error confirming billing:', error)
          })
      },
      async getZones () {
        // Use zones from store
        if (!this.$store.state.zonesLoaded) {
          await this.$store.dispatch('subscribeToZones')
        }
        const storeZones = this.$store.state.zones
        if (!storeZones.length) return

        this.zoneData = storeZones.reduce((acc, zone) => {
          acc[zone.id] = zone
          return acc
        }, {})

        this.zones = storeZones.map(zone => ({
          value: zone.id,
          text: zone.zoneName
        }))

        this.pickZones = this.zones.filter(zone => !this.passedPickZones || this.passedPickZones.includes(zone.value))
        this.dropZones = this.zones.filter(zone => !this.passedDropZones || this.passedDropZones.includes(zone.value))
      },
      filterZones (pickZones, dropZones) {
        this.showFilterZonesModal = false
        this.filteredPickZones = pickZones
        this.filteredDropZones = dropZones

        let pickZonesLength = pickZones.length
        let dropZonesLength = dropZones.length

        if (!pickZonesLength && !dropZonesLength) {
          this.allDeliveries = this.originalProcessing
          return
        }
        this.allDeliveries = this.originalProcessing.filter(ord => {
          return (!pickZonesLength || pickZones.includes(ord.transmitterZoneId)) &&
                   (!dropZonesLength || dropZones.includes(ord.receiverZoneId))
        })
      },
      saveTableCustomizations (tableLayout) {
        try {
          db
            .ref('database/transporter')
            .child(this.companyUID)
            .child('userTableLayouts')
            .child(this.uid)
            .child(this.activeTab)
            .set(tableLayout)
        } catch (error) {
          console.error('Failed to save layout', error)
        }
        this.showCustomizeModal = false
        this.loadFieldsObj()
      },
      closeModals () {
        if (this.billing && this.isOdooBill) {
          this.clearOdooQueue()
        }
        this.billing = false
        this.quickEdit = false
        this.vinPrinting = false
        this.splitLoadModal = false
        this.showCustomizeModal = false
        if (this.quickPayerEdit) {
          this.quickPayerEdit = false
          this.onCloseUpdatePayer()
        }
        this.clear()
        this.clearSelected()
      },
      clearSelected () {
        this.selected = []
        this.selectedFull = []
      },
      onCloseUpdatePayer () {
        this.quickPayerEdit = false
        this.$unbind('pendingAccounts')
        this.clear()
      },
      openVinPrinting () {
        this.fetchSelected()
        this.vinPrinting = true
      },
      openVehicleReadyModal () {
        this.fetchSelected('DISPATCH')
        this.vehicleReadyModal = true
      },
      openStatusEdit () {
        this.fetchSelected('DISPATCH')
        this.isStatusEdit = true
      },
      openLateTimeExtentionModal () {
        this.fetchSelected('DISPATCH')
        this.lateTimeExtension = true
      },
      fetchSelected (action) {
        this.selectedFull = []
        this.selectedFull2 = []
        this.priceOrderLink = []

        let selectedReversed = this.selected.reduce((orderKeys, selectedKey) => {
          const order = this.findOrderForQueueKey(selectedKey)
          const expandedKeys = order ? this.getOrderKeysForQueue(order) : [selectedKey]
          expandedKeys.forEach(orderKey => {
            if (!orderKeys.includes(orderKey)) orderKeys.push(orderKey)
          })
          return orderKeys
        }, [])
        selectedReversed.reverse()

        selectedReversed.forEach((orderId) => {
          db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(orderId).once('value').then((snap) => {
            const selectedFull = this.selectedFull
            const selectedFull2 = this.selectedFull2
            let orderData = snap
            this.setDataFromFetch(selectedFull, selectedFull2, orderData)

            if (action === 'BILLING') this.setFuelCharge()
            if (action === 'DISPATCH' || (action === 'BILLING' && !orderData.val().price)) {
              if (action === 'DISPATCH') {
                this.setPriceOrderLink(orderId, orderData.val())
                this.$set(selectedFull[selectedFull.length - 1], 'comment', 'Client/Customer: ' + orderData.val().payerName)
                if (this.userInfo.driverComment) selectedFull[selectedFull.length - 1].comment += '\n' + orderData.val().comment
              }
            }

            if (!orderData.val().taxes) this.$set(selectedFull[selectedFull.length - 1], 'taxes', '')
            if (!orderData.val().taxesComment) this.$set(selectedFull[selectedFull.length - 1], 'taxesComment', '')
            if (!orderData.val().transmitterCountry) this.$set(selectedFull[selectedFull.length - 1], 'transmitterCountry', '')
            if (!orderData.val().receiverCountry) this.$set(selectedFull[selectedFull.length - 1], 'receiverCountry', '')
            if (!orderData.val().billingDate) this.$set(selectedFull[selectedFull.length - 1], 'billingDate', this.formatDate(Date.now()))
            this.$set(selectedFull[selectedFull.length - 1], 'isReady', true)
            this.order = JSON.parse(JSON.stringify(selectedFull[0]))
          })
        })
      },

      setDataFromFetch (selectedFull, selectedFull2, orderData) {
        this.$set(selectedFull, selectedFull.length, orderData.val())
        this.$set(selectedFull[selectedFull.length - 1], 'orderNumber', orderData.key)
        this.$set(selectedFull[selectedFull.length - 1], 'billOrderNumber', 'QB' + orderData.key)
        this.$set(selectedFull[selectedFull.length - 1], 'fromToBilling', orderData.val().make + ' ' + orderData.val().model + ' ' + orderData.val().year + ' - VIN: ' + orderData.val().vin + ' ' + orderData.val().transmitterName + ' to ' + orderData.val().receiverName)
        const orderFuelCharge = orderData.val().fuelCharge
        const fuelChargePercent = orderFuelCharge !== undefined && orderFuelCharge !== null && orderFuelCharge !== ''
          ? orderFuelCharge
          : this.$store.state.userInfo.fuelCharge || 0
        const fuelChargeAmount = (orderData.val().includedFuelCharge || orderData.val().applyFuelCharge === false)
          ? 0
          : (Number(orderData.val().price) * Number(fuelChargePercent)) / 100

        const obj = {
          'Order': 'QB' + orderData.key,
          'Item': 'Sales',
          'Ref': orderData.val().numRef,
          'Date': orderData.val().billingDate,
          'Price': orderData.val().price,
          'Description': orderData.val().make + ' ' + orderData.val().model + ' ' + orderData.val().year + ' - VIN: ' + orderData.val().vin + ' ' + orderData.val().transmitterName + ' to ' + orderData.val().receiverName + ' Shipped to : ' + orderData.val().receiverProvince,
          'Billing': orderData.val().payerName,
          'Driver': orderData.val().driverName,
          'ToBeEmailed': true,
          'Tax': 'H'
        }

        const obj2 = {
          'Order': 'QB' + orderData.key,
          'Ref': orderData.val().numRef,
          'Item': 'Fuel Surcharge',
          'Date': orderData.val().billingDate,
          'Price': fuelChargeAmount,
          'Description': fuelChargePercent + '%',
          'Billing': orderData.val().payerName,
          'Driver': ' ',
          'ToBeEmailed': true,
          'Tax': 'H'
        }

        this.$set(selectedFull2, selectedFull2.length, obj)
        this.$set(selectedFull2, selectedFull2.length, obj2)
      },

      /** Sets the fuel charge for each order as the @store info */
      // If the order doesn't have a fuel charge, set it to the one of the account
      setFuelCharge () {
        this.selectedFull.forEach(element => {
          let fuelCharge = element.fuelCharge
          if (element.includedFuelCharge || element.applyFuelCharge === false) {
            this.$set(element, 'includedFuelCharge', true)
            this.$set(element, 'applyFuelCharge', false)
          }
          if (fuelCharge === undefined || fuelCharge === null || fuelCharge === '') {
            element.fuelCharge = this.$store.state.userInfo.fuelCharge || 0
          } else {
            console.log('Elsed', this.$store.state.userInfo.fuelCharge)
          }
        })
      },
      updateFuelCharge (order, updatedCharge) {
        this.$set(order, 'fuelCharge', updatedCharge)
        if (updatedCharge !== '') {
          this.$set(order, 'includedFuelCharge', false)
          this.$set(order, 'applyFuelCharge', true)
        }
      },

      setPriceOrderLink (element, orderInfo) {
        let priceObj = {
          orderId: element,
          price: orderInfo.price,
          orderInfo: orderInfo
        }

        this.priceOrderLink.push(priceObj)
      },
      getOrderOdooReference (order) {
        return order.orderBill || order.billNum || order.billId || order.odooBillNumber || order.odooOrderNumber || ''
      },
      getOdooStatusText (order) {
        const orders = order && Array.isArray(order.groupedOrders) ? order.groupedOrders : [order]
        const refs = orders.map(item => this.getOrderOdooReference(item)).filter(Boolean)

        if (refs.length === orders.length) return refs.join(', ')
        if (refs.length > 0) return `${this.$t('OrderCurrent.modal.odoo_partial_sync')}: ${refs.join(', ')}`
        if (orders.some(item => item.odooSyncStatus === 'sync_requested')) return this.$t('OrderCurrent.modal.odoo_sync_requested')
        return this.$t('OrderCurrent.modal.odoo_not_synced')
      },
      getOdooStatusClass (order) {
        const orders = order && Array.isArray(order.groupedOrders) ? order.groupedOrders : [order]
        const refs = orders.map(item => this.getOrderOdooReference(item)).filter(Boolean)

        if (refs.length === orders.length) return 'text-success'
        if (refs.length > 0 || orders.some(item => item.odooSyncStatus === 'sync_requested')) return 'text-warning'
        return 'text-danger'
      },
      buildToBillGroupedOrders (orders) {
        const rows = []
        const groupMap = {}
        const groupOrder = []

        orders.forEach(order => {
          if (order.odooInvoiceGroupEnabled && order.odooInvoiceGroupId) {
            if (!groupMap[order.odooInvoiceGroupId]) {
              groupMap[order.odooInvoiceGroupId] = []
              groupOrder.push(order.odooInvoiceGroupId)
            }
            groupMap[order.odooInvoiceGroupId].push(order)
          } else {
            rows.push(order)
          }
        })

        groupOrder.forEach(groupId => {
          const groupedOrders = groupMap[groupId]
          if (groupedOrders.length === 1) {
            rows.push(groupedOrders[0])
            return
          }

          const firstOrder = groupedOrders[0]
          const totalPrice = groupedOrders.reduce((total, order) => total + (Number(order.price) || 0), 0)
          const totalRegularPrice = groupedOrders.reduce((total, order) => total + (Number(order.regularPrice) || 0), 0)
          rows.push({
            ...firstOrder,
            '.key': `odoo-group-${groupId}`,
            isOdooInvoiceGroupRow: true,
            groupedOrders,
            groupedOrderKeys: groupedOrders.map(order => order['.key']),
            groupedOrderCount: groupedOrders.length,
            price: totalPrice.toFixed(2),
            regularPrice: totalRegularPrice.toFixed(2),
            vin: `${groupedOrders.length} orders`,
            model: `${groupedOrders.length} orders`,
            odooInvoiceGroupId: groupId
          })
        })

        return rows
      },

      loadAddressBook () {
        db.ref('database/transporter/' + this.companyUID + '/addressbook').once('value').then((snap) => {
          let addressbookArray = []
          snap.forEach((element) => {
            let item = element.val()
            item.key = element.key
            if (item.placeId && item.lat && item.long) {
              addressbookArray.push(item)
            }
          })
          this.addressbook = addressbookArray
        })
      },

      generateTooltip (order) {
        if (!order) return '-'

        let htmlParts = []

        if (order.discount != null) {
          htmlParts.push(`Discount: ${order.discount}${order.discountAmountType || '%'}`)
        }

        if (order.surplus != null) {
          htmlParts.push(`Surplus: ${order.surplus}${order.surplusAmountType || '%'}`)
        }

        if (order.surplusByVehicleClass != null) {
          htmlParts.push(`Surplus (by Vehicle Class): ${order.surplusByVehicleClass}%`)
        }

        if (order.surplusRebateNote) {
          htmlParts.push(`Surplus or Rebate Note: ${order.surplusRebateNote}`)
        }

        if (Array.isArray(order.fees) && order.fees.length > 0) {
          order.fees.forEach(fee => {
            if (fee.amount != null && fee.text) {
              htmlParts.push(`${fee.text}: ${fee.amount}$`)
            }
          })
        }

        if (htmlParts.length === 0) return '-'

        return `<p>${htmlParts.join('<br>')}</p>`
      },

      getDate: function (timestamp) {
        var date = new Date(timestamp)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
      },

      getExportDate () {
        var date = new Date()
        var year = date.getFullYear()
        var month = ('0' + (date.getMonth() + 1)).slice(-2)
        var day = ('0' + date.getDate()).slice(-2)
        return year + '-' + month + '-' + day
      },

      formatDate (date) {
        let fdate = new Date(date)
        fdate = fdate.getFullYear() + '-' + ('0' + (fdate.getMonth() + 1)).slice(-2) + '-' + ('0' + fdate.getUTCDate()).slice(-2)

        return fdate
      },

      randomPdfString (length) {
        var text = ''
        var possible = 'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for (var i = 0; i < length; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length))
        }
        return text + '.pdf'
      },

      generateDocuments (order) {
        db.ref('bdcQueue/' + this.companyUID).child(order['.key']).set(this.randomPdfString(12))
      },

      print: function (order) {
        if (!order.isPrinted) {
          // db.ref('test2/transporter/' + this.companyUID + '/deliveries/' + order['.key']).update({'isPrinted': true})
          db.ref('database/transporter/' + this.companyUID + '/deliveries/' + order['.key']).update({'isPrinted': true})
        }
      },

      clear: function () {
        this.clearfeedbackMessage()
        this.dispatchOrder.chauffeur = ''
        this.dispatchOrder.chauffeurName = ''
        for (let attr in this.datalist) {
          this.datalist[attr] = ''
        }
        this.vehicles = []
        this.VIN = ''
        this.MAKE = ''
        this.MODEL = ''
        this.YEAR = ''
        this.SIZE = null
        this.badVin = false
      },

      clearfeedbackMessage () {
        this.feedbackMessage = ''
      },

      shortenString (text) {
        if (typeof text === 'undefined') return text
        else {
          let subString = text.substring(0, 22)
          if (text.length > 22) subString += '...'
          return subString
        }
      },

      getOrderHistoryLength (order) {
        const orderObj = order
        let counter = 0

        for (const key in orderObj.historySync) {
          if (Object.hasOwnProperty.call(orderObj.historySync, key)) {
            counter++
          }
        }
        return counter.toString()
      },

      getDispatchHistoryPrice (historyEntry) {
        if (!historyEntry || typeof historyEntry !== 'object') return 0
        if (historyEntry.price !== undefined && historyEntry.price !== null && historyEntry.price !== '') return Number(historyEntry.price) || 0
        if (historyEntry.prix !== undefined && historyEntry.prix !== null && historyEntry.prix !== '') return Number(historyEntry.prix) || 0
        return 0
      },

      dispatchHistToolTip (order) {
        let text = this.$t('OrderCurrent.dispatch_history_tooltip')

        let orderInfoText = ''

        if (order.historySync) {
          for (const key in order.historySync) {
            if (Object.hasOwnProperty.call(order.historySync, key)) {
              orderInfoText += `${order.historySync[key].transmitterAddress}, ${order.historySync[key].transmitterCity}, ${order.historySync[key].transmitterProvince} -> ${order.historySync[key].receiverAddress}, ${order.historySync[key].receiverCity}, ${order.historySync[key].receiverProvince}, ${this.getDispatchHistoryPrice(order.historySync[key])}$ <br>`
            }
          }
          text = `<strong> ${text} </strong> <br> ${orderInfoText}`
          return text
        }

        return ''
      },

      getOrderNotes (orderNotes) {
        let text = this.$t('OrderCurrent.notes')

        if (orderNotes) {
          for (const key in orderNotes) {
            if (Object.hasOwnProperty.call(orderNotes, key)) {
              const element = orderNotes[key]
              text += `<br> ${element.text} `
            }
          }
        }
        return text
      },

      getOrderSurvey (orderSurvey) {
        let text = '<strong>' + this.$t('Survey.text') + ' </strong> <br>'

        if (orderSurvey) {
          for (const key in orderSurvey) {
            if (Object.hasOwnProperty.call(orderSurvey, key)) {
              const element = orderSurvey[key]
              element.forEach(question => {
                let dateTime = ''
                let openCloseTime = ''

                if (question.dateTime) dateTime = '| ' + this.translateDateTime(question.dateTime)
                if (question.openTime && question.closeTime) openCloseTime = ` | ${this.$t('OrderCurrent.open')}: ${question.openTime} / ${this.$t('OrderCurrent.close')}: ${question.closeTime}`
                text += `<br> ${this.$t(`Survey.question_${question.id}`)} ${this.translateSurveyAnswer(question.answer)} ${dateTime} ${openCloseTime}<br>`
              })
            }
          }
        }

        return text
      },

      translateDateTime (answer) {
        let answerArr = answer.split(',')
        let string = ''

        answerArr.forEach(id => {
          string += this.$t(`Survey.date_${id}`) + ' '
        })

        return string
      },

      translateSurveyAnswer (answer) {
        if (answer === true) return this.$t('General.yes')
        else if (answer === false) return this.$t('General.no')
        else return answer
      },

      getSurveyIconColor (survey) {
        let color = ''
        let colorGreen = 'rgb(3, 115, 3)'
        let colorRed = 'red'

        if (survey) {
          for (const key in survey) {
            if (Object.hasOwnProperty.call(survey, key)) {
              survey[key].forEach(question => {
                if (question.id === '1') color = colorGreen
                if (question.id === '1.1') {
                  let time = this.getTimestamp(question.answer)
                  if (time > Date.now()) color = colorRed
                  else if (time < Date.now()) color = colorGreen
                }
              })
            }
          }
        }

        return color
      },
      lastHistorySync (obj, key) {
        const lastKey = Object.keys(obj)
          .sort((a, b) => {
            const numA = parseInt(a.split('-')[1], 10)
            const numB = parseInt(b.split('-')[1], 10)
            return numA - numB
          })
          .pop()
        if (lastKey && obj[lastKey] && obj[lastKey][key]) {
          return obj[lastKey][key]
        } else {
          return null
        }
      },
      checkDate (date1) {
        var firstDate = new Date(date1)
        var secondDate = new Date()
        if (firstDate <= secondDate) {
          return true
        } else {
          return false
        }
      },
      calcBusinessDays (start2) {
        // This makes no effort to account for holidays
        // Counts end day, does not count start day

        // make copies we can normalize without changing passed in objects
        var start = new Date(start2)
        var end = new Date()

        // initial total
        var totalBusinessDays = 0

        // normalize both start and end to beginning of the day
        start.setHours(0, 0, 0, 0)
        end.setHours(0, 0, 0, 0)

        var current = new Date(start)
        current.setDate(current.getDate() + 1)
        var day
        // loop through each day, checking
        while (current <= end) {
          day = current.getDay()
          if (day >= 1 && day <= 5) {
            ++totalBusinessDays
          }
          current.setDate(current.getDate() + 1)
        }
        return totalBusinessDays
      },

      calcBusinessDays2 (start2) {
        // This makes no effort to account for holidays
        // Counts end day, does not count start day

        // make copies we can normalize without changing passed in objects
        var start = new Date()
        var end = new Date(start2)

        // initial total
        var totalBusinessDays = 0

        // normalize both start and end to beginning of the day
        start.setHours(0, 0, 0, 0)
        end.setHours(0, 0, 0, 0)

        var current = new Date(start)
        current.setDate(current.getDate() + 1)
        var day
        // loop through each day, checking
        while (current <= end) {
          day = current.getDay()
          if (day >= 1 && day <= 5) {
            ++totalBusinessDays
          }
          current.setDate(current.getDate() + 1)
        }
        return totalBusinessDays
      },
      getTimestamp (receivedDate) {
        let timestamp = Date.parse(receivedDate)
        return timestamp
      },
      isWarningOrder (order) {
        const statuses = [ 'Processing', 'Reject', 'Attente', 'Transit' ]

        if (!order.warningTime) return false

        const currentDate = Date.now()

        return (statuses.includes(order.status) && currentDate >= order.warningTime)
      },
      isChecked (orderKey) {
        return this.selected.includes(orderKey)
      },
      isLateOrder (order) {
        const statuses = [ 'Processing', 'Reject', 'Attente', 'Transit' ]

        if (!order.status) return false

        if (!order.lateTime) return false

        const currentDate = Date.now()

        return (statuses.includes(order.status) && currentDate >= order.lateTime)
      },
      disableActions (order) {
        // return this.lateOrdersPresent && !order.isLate
        return false
      },
      syncLateOrderState () {
        const sourceOrders = Array.isArray(this.originalProcessing) ? this.originalProcessing : []
        const warningOrders = []
        const lateOrders = []
        const hydratedOrders = sourceOrders.map((order) => {
          const isLate = this.isLateOrder(order)
          const isWarning = !isLate && this.isWarningOrder(order)
          const hydratedOrder = {
            ...order,
            isLate,
            isWarning
          }

          if (isLate) lateOrders.push(hydratedOrder)
          else if (isWarning) warningOrders.push(hydratedOrder)

          return hydratedOrder
        })

        this.lateOrders = lateOrders
        this.lateOrdersPresent = lateOrders.length > 0

        if (this.visibleLateOrders) {
          this.allDeliveries = [...warningOrders, ...lateOrders]
          return
        }

        this.allDeliveries = hydratedOrders
      },
      getVehicleType (id) {
        if (id === 2) {
          return 'light'
        }
        if (id === 3) {
          return 'medium'
        }
        if (id === 4) {
          return 'heavy'
        }
        if (id === 5) {
          return 'extra_heavy'
        }
        return 'not_standard'
      },
      showLateOrders () {
        this.visibleLateOrders = !this.visibleLateOrders
        this.validateLateOrders()
      },
      showNormalList () {
        this.visibleLateOrders = false
        this.syncLateOrderState()
      },
      validateLateOrders () {
        this.syncLateOrderState()
      },
      updateFilterResults (sortResults) {
          this.filterResults = sortResults
          this.$emit('filterResultsUpdated', sortResults)
      },
      updateSelectedOrders (selected) {
          this.selected = selected
      }
    },

    computed: {
      hasFullAccess () {
        return this.$store.state.userInfo.userType === 'full'
      },
      canManageInventory () {
        return this.hasFullAccess && !this.isViewer
      },
      inventoryDrivers () {
        return this.liste.length ? this.liste : this.inventoryDriverList
      },
      calculateSortSpacing () {
        if (this.isDateRoute && !this.currentPageBtn) {
          return 6
        } else if (this.isDateRoute && this.currentPageBtn) {
          return 5
        } else if (!this.isDateRoute && this.currentPageBtn) {
          return 4
        }
        // !isDateRoute && !currentPageBtn (delivered, toBill, waiting)
        return 4 // checkbox + view + print + address check
      },
      checkUpdateKey () {
        if (this.updateKey) return true
        else return false
      },
      filteredOrders () {
        const orders = this.showUnlistedOrders ? this.unlistedProcessing : this.allDeliveries
        if (this.fromToBillPage && Array.isArray(orders)) return this.buildToBillGroupedOrders(orders)
        return orders
      },
      selectedInventoryOrders () {
        const selectedOrders = []
        const seen = new Set()

        this.selected.forEach(selectedKey => {
          const visibleOrder = this.findOrderForQueueKey(selectedKey)
          const orderKeys = visibleOrder ? this.getOrderKeysForQueue(visibleOrder) : [selectedKey]

          orderKeys.forEach(orderKey => {
            if (seen.has(orderKey)) return
            const order = this.originalProcessing.find(entry => entry && entry['.key'] === orderKey)
            if (!order || order.isInventory === true) return
            seen.add(orderKey)
            selectedOrders.push(order)
          })
        })

        return selectedOrders
      },
      hasEligibleInventorySelection () {
        return this.selectedInventoryOrders.some(order => order.sentToInventory !== true)
      },
      vinsList () {
        return this.allDeliveries
          .map(o => ({
            vin: o.vin,
            status: o.status,
            orderNumber: o['.key']
          }))
      },
      tableLayoutOptions () {
        const options = [
          {
            text: this.$t('OrderCurrent.order'),
            value: '.key'
          },
          {
            text: this.$t('OrderCurrent.reference'),
            value: 'numRef'
          },
          {
            text: this.fieldLabel('vin'),
            value: 'vin'
          },
          {
            text: this.fieldLabel('model'),
            value: 'model'
          },
          {
            text: this.$t('OrderCurrent.pickup'),
            value: 'transmitterName'
          },
          {
            text: this.$t('OrderCurrent.delivery'),
            value: 'receiverName'
          },
          {
            text: this.$t('OrderCurrent.billing'),
            value: 'payerName'
          },
          {
            text: this.$t('OrderCurrent.status'),
            value: 'status'
          },
          {
            text: this.$t('OrderCurrent.driver'),
            value: 'driverName'
          },
          {
            text: this.$t('OrderCurrent.eta'),
            value: 'eta'
          },
          {
            text: this.$t('OrderDelivered.expected_price'),
            value: 'regularPrice'
          }
        ]
        if (this.isDryBox) {
          options.push(
            {
              text: this.$t('DryBox.qty'),
              value: 'year'
            },
            {
              text: this.$t('DryBox.line_weight'),
              value: 'weight'
            },
            {
              text: this.$t('DryBox.linear_feet'),
              value: 'linearFeet'
            }
          )
        }
        return options
      },
      fuelChargeProxy: {
        get () {
          return this.order.applyFuelCharge === false ? 0 : this.order.fuelCharge
        },
        set (value) {
          if (value !== '') {
            this.$set(this.order, 'includedFuelCharge', false)
            this.$set(this.order, 'applyFuelCharge', true)
          }
          this.order.fuelCharge = value
        }
      },
      orderTiming () {
        return (order) => {
          const MS_IN_DAY = 1000 * 60 * 60 * 24

          const warningTime = Number(order.warningTime)
          const lateTime = Number(order.lateTime)

          let eta = ''
          let delay = 0

          if (warningTime && lateTime) {
            const start = new Date(warningTime)
            const end = new Date(lateTime)

            const formatDate = (d) =>
              d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })

            eta = `${formatDate(start)} - ${formatDate(end)}`
          }

          if (lateTime) {
            delay = Math.max(0, Math.floor((Date.now() - lateTime) / MS_IN_DAY))
          }

          return { eta, delay }
        }
      },
      companyUID () {
        return this.$store.state.authorization.company
      },
      uid () {
        return this.$store.state.user.uid
      },
      sageIDonly () {
        return this.addressbook.filter(customer => customer.sageID)
      },
      hasProvince () {
        return this.addressbook.filter(customer => customer.province && customer.city && customer.country)
      },
      isQuickBook () {
        return this.$store.state.userInfo.isQuickbook
      },
      userInfo () {
        return this.$store.state.userInfo
      },
      hasIntegration () {
        return this.$store.state.userInfo.hasIntegration
      },
      isDateRoute () {
        return this.$route.query.newDate
      },
      isAdmin () {
        return this.$store.state.authorization.role === 'Admin'
      },
      isViewer () {
        return this.$store.state.authorization.role === 'Viewer'
      },
      isOdooBillingEnabled () {
        return this.$store.state.userInfo.featureFlags && this.$store.state.userInfo.featureFlags.odooBilling
      }
    },
    watch: {
      arrOfOrders: {
        immediate: true,
        handler (val) {
          this.originalProcessing = Array.isArray(val) ? val.filter(isRegularOrder) : []
          this.syncLateOrderState()
        }
      },
      $route (to, from) {
        this.fieldsObj = []
        this.loadFieldsObj()
      },
      lateOrdersArr: {
        immediate: true,
        handler (val) {
          this.lateOrders = Array.isArray(val) ? val : []
        }
      },
      billingSame: function (val) {
        var order = this.order
        if (!val) {
          order.payerAddress = ''
          order.payerCity = ''
          order.payerContact = ''
          order.payerFax = ''
          order.payerName = ''
          order.payerPhone = ''
          order.payerEmail = ''
          order.payerPostcode = ''
          order.payerProvince = ''
          order.payerCountry = ''
          order.sageID = ''
        } else {
          order.payerAddress = order.receiverAddress
          order.payerCity = order.receiverCity
          order.payerContact = order.receiverContact
          order.payerFax = order.receiverFax
          order.payerName = order.receiverName
          order.payerPhone = order.receiverPhone
          order.payerEmail = order.receiverEmail
          order.payerPostcode = order.receiverPostcode
          order.payerProvince = order.receiverProvince
          order.payerCountry = order.receiverCountry
          order.sageID = this.backup.sageIDDelivery || ''
          this.datalist.billing = ''
          this.datalist.billingUid = ''
        }
      }
  }
}
</script>

<style scoped>
  .dispatch-info-tab {
    display: flex;
    flex-flow: row;
  }

  .preBody {
    display: flex;
    justify-content: space-between;

  }
  .table thead th{
    border-bottom: 1px solid #eceeef;
    border-top: none;
  }
  #addOrder, #customView{
    position: relative;
  }

  .printed{
    background-color: #79cc79 !important;
    border-color: #79cc79 !important;
  }
  .kne-tab:hover{
    color: #f7941e !important;
  }
  .kne-tab.active{
    color: #f7941e !important;
  }
  th{
    resize: horizontal;
  }
  .view{
    padding-left: 11rem;
  }
  .sidebar{
    width: 10.5rem;
  }
  .current{
    border-left: 3px solid #f7941e;
  }
  #checkBox{
    width: 1.25rem;
    height: 1.25rem;
  }
  #fileIcon{
    margin-top: 0.70rem;
  }

  .fa-exclamation{
    margin-left: 0.25rem;
  }

  .input--missing {
    border: solid 1px;
    border-color: rgb(211, 116, 116);
    border-radius: 5px;
  }

  .toggleSwitch {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #priceSection label {
    margin-left: 1rem;
  }

  .newOrder__container--display {
    display: flex;
    flex-flow: row;
    width: 50%;
  }

  .newOrder__container--display-mobile {
    display: flex;
    flex-flow: column;
    width: 100%;
  }

  .document-date__container {
    display: flex;
    justify-content: space-between;
  }

  .document-date__container--mobile {
    flex-direction: column;
  }

  .document-date__item {
    width: 45%;
  }

  .document-date__item--mobile {
    width: 100%;
  }

  .document-date__button-red {
    background-color: rgb(255, 58, 58);
  }
  .icon-size {
    font-size: 1.5rem;
  }

  .flex-row {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .header-actions{
    display:flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
  }
  .customize-btn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 10px;
  }
  .fw-700{
    font-weight: 700;
  }
 
  .red, .red:focus, .red:hover {
    color: #ece7e7;
    background-color: #ad0001d1 !important;
  }
 
  .orange, .orange:focus {
    background-color: #ffa5009e !important;
    color: #353535
  }

  .yellow, .yellow:hover {
    background-color: #ffff00a3 !important;
  }

  .uncheck {
    background-image: none !important;
    background-color: #fff !important;
  }

  .check {
    background-image: url('data:image/svg+xml;charset=utf8,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8"%3E%3Cpath fill="%23fff" d="M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z"/%3E%3C/svg%3E') !important;
    background-color: #0275d8 !important;
  }

  .tooltip-wrapper {
    position: relative;
    display: inline-block;
  }

  .tooltip-text {
    visibility: hidden;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 4px;
    padding: 4px 8px;
    position: absolute;
    z-index: 1;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: 12px;
  }

  .tooltip-wrapper:hover .tooltip-text {
    visibility: visible;
  }

  .to-bill-actions {
    align-items: center;
    gap: 4px;
  }

  .odoo-status-text {
    min-width: 92px;
    display: inline-block;
    font-weight: 600;
  }

  .grouped-orders-list {
    font-size: 12px;
    white-space: normal;
    max-width: 260px;
  }

</style>
